import { render, staticRenderFns } from "./ideaResult.vue?vue&type=template&id=7f23ab7c&scoped=true"
import script from "./ideaResult.vue?vue&type=script&lang=js"
export * from "./ideaResult.vue?vue&type=script&lang=js"
import style0 from "./ideaResult.vue?vue&type=style&index=0&id=7f23ab7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f23ab7c",
  null
  
)

export default component.exports